module.exports = __webpack_public_path__ + "static/media/bichito-sorprendido.0c440e5c.png";